"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshApiKey = exports.createApiKey = exports.retrievePwd = exports.updatePwd = exports.isExistEmail = exports.emailCodeVerify = exports.smsVerify = exports.bindMobile = exports.bindEmail = exports.getEmailCode = exports.getSmsCode = exports.register = exports.signUp = exports.revokeLogout = exports.logout = exports.signOut = exports.signIn = exports.signInOrSignUp = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("../../shared/api/url"));
/**
 * Login / Register (get identity token directly)
 * @param data
 * @returns
 */
function signInOrSignUp(data) {
    return axios_1.default.post(Url.SIGN_IN_OR_SIGN_UP, Object.assign({}, data));
}
exports.signInOrSignUp = signInOrSignUp;
/**
 * Sign In
 * @param data
 * @returns
 */
function signIn(data) {
    return axios_1.default.post(Url.SIGN_IN, Object.assign({}, data));
}
exports.signIn = signIn;
/**
 * Sign Out
 *
 * @returns
 */
function signOut() {
    return axios_1.default.post(Url.SIGN_OUT);
}
exports.signOut = signOut;
/**
 * Close the user, delete the account
 *
 * @returns
 */
function logout() {
    return axios_1.default.post(Url.CLOSE_USER);
}
exports.logout = logout;
/**
 * Cancel close the user, cancel delete the account
 * @returns
 */
function revokeLogout() {
    return axios_1.default.post(Url.CANCEL_CLOSE_USER);
}
exports.revokeLogout = revokeLogout;
/**
 *
 * Register
 *
 * @param phone phone number
 * @param password password
 * @param code verify code
 */
function signUp(token, inviteCode) {
    return axios_1.default.post(Url.SIGN_UP, {
        token,
        inviteCode,
    });
}
exports.signUp = signUp;
/**
 * APITable CE Register
 *
 */
function register(username, credential) {
    return axios_1.default.post(Url.REGISTER, {
        username,
        credential
    });
}
exports.register = register;
/**
 *
 * Get phone verification code
 *
 * @param phone Phone Number
 * @param type 1:Register, 3:Edit password
 * @param data CAPTCHA arguments
 */
function getSmsCode(areaCode, phone, type, data) {
    return axios_1.default.post(Url.SEND_SMS_CODE, {
        areaCode,
        phone,
        type,
        data,
    });
}
exports.getSmsCode = getSmsCode;
/**
 * Get Email Verify Code
 *
 * @param email mail
 */
function getEmailCode(email, type) {
    return axios_1.default.post(Url.SEND_EMAIL_CODE, {
        email,
        type,
    });
}
exports.getEmailCode = getEmailCode;
/**
 * Bind the email
 * @param email
 * @param code
 */
function bindEmail(email, code) {
    return axios_1.default.post(Url.BIND_EMAIL, {
        email,
        code,
    });
}
exports.bindEmail = bindEmail;
/**
 * Bind the mobile phone
 *
 * @param phone
 * @param code
 */
function bindMobile(areaCode, phone, code) {
    return axios_1.default.post(Url.BIND_MOBILE, {
        areaCode,
        phone,
        code,
    });
}
exports.bindMobile = bindMobile;
/**
 * Verify the mobile phone code
 * @param phone
 * @param code
 */
function smsVerify(areaCode, phone, code) {
    return axios_1.default.post(Url.VALIDATE_SMS_CODE, {
        areaCode,
        phone,
        code,
    });
}
exports.smsVerify = smsVerify;
/**
 * Verify the email code
 * When you don't have a mobile phone
 * you can verify your identity before changing your mailbox or changing the main administrator
 */
function emailCodeVerify(email, code) {
    return axios_1.default.post(Url.VALIDATE_EMAIL_CODE, {
        email,
        code,
    });
}
exports.emailCodeVerify = emailCodeVerify;
/**
 * Check whether the email exists in the space
 * @param email
 */
function isExistEmail(email) {
    return axios_1.default.get(Url.EXIST_EMAIL, {
        params: {
            email,
        },
    });
}
exports.isExistEmail = isExistEmail;
/**
 * Edit password
 * @param phone
 * @param code verify code
 * @param password password
 */
function updatePwd(password, code, type) {
    return axios_1.default.post(Url.UPDATE_PWD, {
        code,
        password,
        type,
    });
}
exports.updatePwd = updatePwd;
/**
 * Forgot password
 *
 * @param phone
 * @param password
 */
function retrievePwd(areaCode, username, code, password, type) {
    return axios_1.default.post(Url.RETRIEVE_PWD, {
        areaCode,
        username,
        code,
        password,
        type,
    });
}
exports.retrievePwd = retrievePwd;
/**
 * create developer access token
 * @returns
 */
function createApiKey() {
    return axios_1.default.post(Url.CREATE_API_KEY);
}
exports.createApiKey = createApiKey;
/**
 * refresh developer access token
 * @param code
 * @param type
 * @returns
 */
function refreshApiKey(code, type) {
    return axios_1.default.post(Url.REFRESH_API_KEY, { code, type });
}
exports.refreshApiKey = refreshApiKey;
//# sourceMappingURL=api.auth.js.map